import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
/* eslint-disable no-undef */
import React, { Component, Fragment } from 'react';
import Fuse from 'fuse.js';
import { Helmet } from '../../lib/react-helmet-async';
import { debounce } from '../../helpers/debounce';
import { centreType } from '../../types';
import SearchField from '../search-field';
import style from './index.module.scss';
import Store from './store';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class CentreMap extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      filteredStores: [],
      selectedStore: null,
      searchValue: '',
      ready: false
    });
    _defineProperty(this, "clearSelectedStore", () => {
      // eslint-disable-next-line no-unused-expressions
      this.state.selectedStore !== null && this.setState({
        selectedStore: null
      });
    });
    //
    // Find a store by the legacyIdentifier.
    //
    // NOTE: may return undefined.
    //
    _defineProperty(this, "findStore", externalId => this.props.stores.find(store =>
    // eslint-disable-next-line eqeqeq
    store.legacyIdentifier == externalId || store.sys.id === externalId));
    //
    // Highlight selected store by showing at bottom of page.
    // If no store was found, we clear the selectedStore state.
    //
    _defineProperty(this, "showStore", externalId => {
      const store = this.findStore(externalId);
      if (store) {
        this.setState({
          selectedStore: store
        });
      } else {
        this.deselectStore();
      }
    });
    _defineProperty(this, "deselectStore", () => {
      this.setState({
        selectedStore: null
      });
    });
    _defineProperty(this, "receivePostMessage", message => {
      if (message.origin !== window.location.origin) {
        return;
      }
      if (message.data.event === 'ready') {
        this.setState({
          ready: true
        });
      }
      if (message.data.event === 'jibestream-more-info') {
        const {
          externalId
        } = message.data;
        this.showStore(externalId);
      }
    });
    _defineProperty(this, "updateSearchResults", () => {
      const searchValue = this.searchField.value;
      this.setState({
        searchValue,
        filteredStores: this.searchStores(searchValue)
      });
    });
    _defineProperty(this, "handleOnChangeSearch", debounce(this.updateSearchResults));
    _defineProperty(this, "searchStores", term => {
      if (term.length < 1) {
        return [];
      }
      const options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        keys: ['title']
      };
      return new Fuse(this.props.stores, options).search(term);
    });
    _defineProperty(this, "selectStore", (event, selectedStore) => {
      event.preventDefault();
      this.setState({
        selectedStore,
        filteredStores: []
      });
      this.mapFrame.contentWindow.postMessage({
        event: 'select-store',
        legacyId: selectedStore.legacyIdentifier,
        entryid: selectedStore.sys.id
      }, window.location.origin);
    });
  }
  componentDidMount() {
    window.addEventListener('message', this.receivePostMessage);
    window.addEventListener('storage', this.clearSelectedStore);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.receivePostMessage);
  }
  render() {
    const {
      centre: {
        title: centreName,
        jibestreamVenueId
      },
      legacyIdentifier,
      entryId
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Helmet, {
        "data-id": "centre-map_index_Fragment_Helmet",
        children: /*#__PURE__*/_jsx("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/static/css/maps.static.css",
          "data-id": "centre-map_index_Helmet_link"
        })
      }), /*#__PURE__*/_jsx("iframe", {
        title: "Centre Map",
        id: "map",
        className: "mapFrame",
        ref: elem => this.mapFrame = elem,
        src: "/jibestream-map/map.html?venueId=".concat(jibestreamVenueId, "&externalId=").concat(legacyIdentifier, "&entryId=").concat(entryId),
        "data-id": "centre-map_index_Fragment_iframe"
      }), this.state.ready && /*#__PURE__*/_jsxs("div", {
        className: style.searchField,
        "data-id": "centre-map_index_div",
        children: [/*#__PURE__*/_jsx(SearchField, {
          id: "searchInp",
          value: this.state.searchValue,
          placeholder: "Find stores in ".concat(centreName),
          innerRef: elem => this.searchField = elem,
          autoCorrect: "off",
          autoComplete: "off",
          onChange: this.handleOnChangeSearch,
          "data-id": "centre-map_index_div_SearchField"
        }), this.state.filteredStores.length > 0 && /*#__PURE__*/_jsx("div", {
          className: style.filteredStores,
          "data-id": "centre-map_index_div",
          children: this.state.filteredStores.map((filteredStore, index) => /*#__PURE__*/_jsx(Store, {
            dataTestId: "filtered-store-name",
            store: filteredStore,
            selectStore: event => this.selectStore(event, filteredStore),
            "data-id": "centre-map_index_Store"
          }, "map-store-".concat(index)))
        })]
      }), this.state.selectedStore && /*#__PURE__*/_jsx("div", {
        className: style.selectedStore,
        "data-id": "centre-map_index_div",
        children: /*#__PURE__*/_jsx(Store, {
          dataTestId: "selected-store-name",
          store: this.state.selectedStore,
          deselectStore: this.deselectStore,
          "data-id": "centre-map_index_div_Store"
        })
      })]
    });
  }
}
export default CentreMap;